import type { ReactNode } from 'react';
import styles from '../Dashboard.module.scss';

interface InsightCardHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  badge: string;
}

export function InsightCardHeader({ icon, title, subtitle, badge }: InsightCardHeaderProps) {
  return (
    <div className={styles.insightHeader}>
      <div className={styles.insightHeaderIcon}>{icon}</div>
      <div className={styles.insightHeaderText}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.cardSubtitle}>{subtitle}</p>
      </div>
      <span className={styles.cardBadge}>{badge}</span>
    </div>
  );
}
